/* eslint-disable consistent-return */
import { isAuthorized, tryToRefreshToken } from '../../services/auth.service';
import store from '@/store';
/**
 * @override
 */
export default async function(to, from, next) {
  if (
    to.name === 'login' ||
    to.name === 'login365' ||
    to.name === 'login-third-party' ||
    to.name === 'password-reset' ||
    to.name === 'new-password' ||
    isAuthorized()
  ) {
    return next();
  } else {
    try {
      await tryToRefreshToken();
      return next();
    } catch (err) {
      console.warn(err);
      store.dispatch('yuriMenuStore/reset');
      store.dispatch('formStore/deleteAllForms');
      return next(`/login`);
    }
  }
}
